/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 0.0.1
 */

/**
 * Surveillance type
 */
export type CreateReportDtoSurveillanceType =
  (typeof CreateReportDtoSurveillanceType)[keyof typeof CreateReportDtoSurveillanceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateReportDtoSurveillanceType = {
  active: 'active',
  passive: 'passive',
  other: 'other',
} as const;
